module.exports = __webpack_public_path__ + "static/img/hydw.2925021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/hydw.jpg
// module id = 3bfv
// module chunks = 21